import * as React from 'react';

export interface IOfficeViewerProps {
    fileDownloadUri: string;
    currentWidth?: number;
}

export default function OfficeViewer(props: IOfficeViewerProps) {
    const getOfficeViewerUrl = (fileUrl: string) => {
        // Encode the file URL to be used as a parameter
        const encodedUrl = encodeURIComponent(fileUrl);
        return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
    };
    return (
        <div style={{
            height: "calc(100vh - 246px)", width: props.currentWidth ?? '100%'
        }}>
            < iframe
                src={getOfficeViewerUrl(props.fileDownloadUri)}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Office Document Viewer"
            />
        </div>
    );
}
